import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import FilterGroup from "./components/FilterGroup";
import FilterItem from "./components/FilterItem";
import FilterSection from "./components/FilterSection";
import FilterSectionOverflow from "./components/FilterSectionOverflow";
import Filters from "./components/Filters";
import Link from "./components/Link";
import Section from "./components/Section";
import Selected from "./components/Selected";
import SelectedGroup from "./components/SelectedGroup";
import SelectedItem from "./components/SelectedItem";

var SearchFilters = function SearchFilters(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory(SearchFilters.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, children);
};

SearchFilters.displayName = "SearchFilters";
SearchFilters.FilterGroup = FilterGroup;
SearchFilters.FilterItem = FilterItem;
SearchFilters.FilterSection = FilterSection;
SearchFilters.FilterSectionOverflow = FilterSectionOverflow;
SearchFilters.Filters = Filters;
SearchFilters.Link = Link;
SearchFilters.Section = Section;
SearchFilters.Selected = Selected;
SearchFilters.SelectedGroup = SelectedGroup;
SearchFilters.SelectedItem = SelectedItem;
export default SearchFilters;